/* eslint-disable */
import { Timestamp } from "../../../google/protobuf/timestamp";
import { DateMessage } from "../../common/date";

export const protobufPackage = "od_protos.web.data";

/**
 * Data specific to an offer comp from Web
 * Next ID: 7
 */
export interface Comp {
  id: string;
  address?: Address | undefined;
  deltas?: Deltas | undefined;
  photo: string;
  homeDetails?: HomeDetails | undefined;
  listingDetails?: ListingDetails | undefined;
}

/** Next ID: 20 */
export interface Address {
  id: string;
  addressToken: string;
  city: string;
  latitude: string;
  longitude: string;
  postalCode: string;
  state: string;
  street1: string;
  unit: string;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  apn: string;
  isMissingUnitNumber: boolean;
  signature: string;
  valuationNotes: string;
  slug: string;
  lonlat: string;
}

/** Next ID: 10 */
export interface Deltas {
  bathroomsFull: number;
  bathroomsHalf: number;
  bedrooms: number;
  exteriorStories: number;
  garageSpaces: number;
  lotSqFt: number;
  pool: number;
  sqFt: number;
  yearBuilt: number;
}

/** Next ID: 12 */
export interface HomeDetails {
  bathroomsFull: number;
  bathroomsHalf: number;
  bedrooms: number;
  exteriorStories: number;
  garageSpaces: number;
  lotSqFt: number;
  pool: boolean;
  sqFt: number;
  yearBuilt: number;
  aboveGradeSqFt: number;
  basementSqFt: number;
}

/** Next ID: 15 */
export interface ListingDetails {
  daysOnMarket: number;
  listPrice: number;
  originalListPrice: number;
  closePrice: number;
  /** Deprecated 5 */
  closeDate?:
    | Date
    | undefined;
  /** "2" appended indicates an updated field type, we switched from timestamps to a date */
  closeDate2?:
    | DateMessage
    | undefined;
  /** Deprecated 6 */
  pendingDate?:
    | Date
    | undefined;
  /** "2" appended indicates an updated field type, we switched from timestamps to a date */
  pendingDate2?:
    | DateMessage
    | undefined;
  /** Deprecated 7 */
  listDate?:
    | Date
    | undefined;
  /** "2" appended indicates an updated field type, we switched from timestamps to a date */
  listDate2?: DateMessage | undefined;
  listingStatus: string;
  sellerConcession: number;
  /** Deprecated 10 */
  statusChangeDate?:
    | Date
    | undefined;
  /** "2" appended indicates an updated field type, we switched from timestamps to a date */
  statusChangeDate2?: DateMessage | undefined;
}

function createBaseComp(): Comp {
  return {
    id: "",
    address: undefined,
    deltas: undefined,
    photo: "",
    homeDetails: undefined,
    listingDetails: undefined,
  };
}

export const Comp = {
  fromJSON(object: any): Comp {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      address: isSet(object.address) ? Address.fromJSON(object.address) : undefined,
      deltas: isSet(object.deltas) ? Deltas.fromJSON(object.deltas) : undefined,
      photo: isSet(object.photo) ? String(object.photo) : "",
      homeDetails: isSet(object.homeDetails) ? HomeDetails.fromJSON(object.homeDetails) : undefined,
      listingDetails: isSet(object.listingDetails) ? ListingDetails.fromJSON(object.listingDetails) : undefined,
    };
  },

  toJSON(message: Comp): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.address !== undefined) {
      obj.address = Address.toJSON(message.address);
    }
    if (message.deltas !== undefined) {
      obj.deltas = Deltas.toJSON(message.deltas);
    }
    if (message.photo !== "") {
      obj.photo = message.photo;
    }
    if (message.homeDetails !== undefined) {
      obj.homeDetails = HomeDetails.toJSON(message.homeDetails);
    }
    if (message.listingDetails !== undefined) {
      obj.listingDetails = ListingDetails.toJSON(message.listingDetails);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Comp>, I>>(base?: I): Comp {
    return Comp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Comp>, I>>(object: I): Comp {
    const message = createBaseComp();
    message.id = object.id ?? "";
    message.address = (object.address !== undefined && object.address !== null)
      ? Address.fromPartial(object.address)
      : undefined;
    message.deltas = (object.deltas !== undefined && object.deltas !== null)
      ? Deltas.fromPartial(object.deltas)
      : undefined;
    message.photo = object.photo ?? "";
    message.homeDetails = (object.homeDetails !== undefined && object.homeDetails !== null)
      ? HomeDetails.fromPartial(object.homeDetails)
      : undefined;
    message.listingDetails = (object.listingDetails !== undefined && object.listingDetails !== null)
      ? ListingDetails.fromPartial(object.listingDetails)
      : undefined;
    return message;
  },
};

function createBaseAddress(): Address {
  return {
    id: "",
    addressToken: "",
    city: "",
    latitude: "",
    longitude: "",
    postalCode: "",
    state: "",
    street1: "",
    unit: "",
    createdAt: undefined,
    updatedAt: undefined,
    apn: "",
    isMissingUnitNumber: false,
    signature: "",
    valuationNotes: "",
    slug: "",
    lonlat: "",
  };
}

export const Address = {
  fromJSON(object: any): Address {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      addressToken: isSet(object.addressToken) ? String(object.addressToken) : "",
      city: isSet(object.city) ? String(object.city) : "",
      latitude: isSet(object.latitude) ? String(object.latitude) : "",
      longitude: isSet(object.longitude) ? String(object.longitude) : "",
      postalCode: isSet(object.postalCode) ? String(object.postalCode) : "",
      state: isSet(object.state) ? String(object.state) : "",
      street1: isSet(object.street1) ? String(object.street1) : "",
      unit: isSet(object.unit) ? String(object.unit) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
      apn: isSet(object.apn) ? String(object.apn) : "",
      isMissingUnitNumber: isSet(object.isMissingUnitNumber) ? Boolean(object.isMissingUnitNumber) : false,
      signature: isSet(object.signature) ? String(object.signature) : "",
      valuationNotes: isSet(object.valuationNotes) ? String(object.valuationNotes) : "",
      slug: isSet(object.slug) ? String(object.slug) : "",
      lonlat: isSet(object.lonlat) ? String(object.lonlat) : "",
    };
  },

  toJSON(message: Address): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.addressToken !== "") {
      obj.addressToken = message.addressToken;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.latitude !== "") {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== "") {
      obj.longitude = message.longitude;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.street1 !== "") {
      obj.street1 = message.street1;
    }
    if (message.unit !== "") {
      obj.unit = message.unit;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.apn !== "") {
      obj.apn = message.apn;
    }
    if (message.isMissingUnitNumber === true) {
      obj.isMissingUnitNumber = message.isMissingUnitNumber;
    }
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message.valuationNotes !== "") {
      obj.valuationNotes = message.valuationNotes;
    }
    if (message.slug !== "") {
      obj.slug = message.slug;
    }
    if (message.lonlat !== "") {
      obj.lonlat = message.lonlat;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Address>, I>>(base?: I): Address {
    return Address.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Address>, I>>(object: I): Address {
    const message = createBaseAddress();
    message.id = object.id ?? "";
    message.addressToken = object.addressToken ?? "";
    message.city = object.city ?? "";
    message.latitude = object.latitude ?? "";
    message.longitude = object.longitude ?? "";
    message.postalCode = object.postalCode ?? "";
    message.state = object.state ?? "";
    message.street1 = object.street1 ?? "";
    message.unit = object.unit ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.apn = object.apn ?? "";
    message.isMissingUnitNumber = object.isMissingUnitNumber ?? false;
    message.signature = object.signature ?? "";
    message.valuationNotes = object.valuationNotes ?? "";
    message.slug = object.slug ?? "";
    message.lonlat = object.lonlat ?? "";
    return message;
  },
};

function createBaseDeltas(): Deltas {
  return {
    bathroomsFull: 0,
    bathroomsHalf: 0,
    bedrooms: 0,
    exteriorStories: 0,
    garageSpaces: 0,
    lotSqFt: 0,
    pool: 0,
    sqFt: 0,
    yearBuilt: 0,
  };
}

export const Deltas = {
  fromJSON(object: any): Deltas {
    return {
      bathroomsFull: isSet(object.bathroomsFull) ? Number(object.bathroomsFull) : 0,
      bathroomsHalf: isSet(object.bathroomsHalf) ? Number(object.bathroomsHalf) : 0,
      bedrooms: isSet(object.bedrooms) ? Number(object.bedrooms) : 0,
      exteriorStories: isSet(object.exteriorStories) ? Number(object.exteriorStories) : 0,
      garageSpaces: isSet(object.garageSpaces) ? Number(object.garageSpaces) : 0,
      lotSqFt: isSet(object.lotSqFt) ? Number(object.lotSqFt) : 0,
      pool: isSet(object.pool) ? Number(object.pool) : 0,
      sqFt: isSet(object.sqFt) ? Number(object.sqFt) : 0,
      yearBuilt: isSet(object.yearBuilt) ? Number(object.yearBuilt) : 0,
    };
  },

  toJSON(message: Deltas): unknown {
    const obj: any = {};
    if (message.bathroomsFull !== 0) {
      obj.bathroomsFull = Math.round(message.bathroomsFull);
    }
    if (message.bathroomsHalf !== 0) {
      obj.bathroomsHalf = Math.round(message.bathroomsHalf);
    }
    if (message.bedrooms !== 0) {
      obj.bedrooms = Math.round(message.bedrooms);
    }
    if (message.exteriorStories !== 0) {
      obj.exteriorStories = Math.round(message.exteriorStories);
    }
    if (message.garageSpaces !== 0) {
      obj.garageSpaces = Math.round(message.garageSpaces);
    }
    if (message.lotSqFt !== 0) {
      obj.lotSqFt = Math.round(message.lotSqFt);
    }
    if (message.pool !== 0) {
      obj.pool = Math.round(message.pool);
    }
    if (message.sqFt !== 0) {
      obj.sqFt = Math.round(message.sqFt);
    }
    if (message.yearBuilt !== 0) {
      obj.yearBuilt = Math.round(message.yearBuilt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Deltas>, I>>(base?: I): Deltas {
    return Deltas.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Deltas>, I>>(object: I): Deltas {
    const message = createBaseDeltas();
    message.bathroomsFull = object.bathroomsFull ?? 0;
    message.bathroomsHalf = object.bathroomsHalf ?? 0;
    message.bedrooms = object.bedrooms ?? 0;
    message.exteriorStories = object.exteriorStories ?? 0;
    message.garageSpaces = object.garageSpaces ?? 0;
    message.lotSqFt = object.lotSqFt ?? 0;
    message.pool = object.pool ?? 0;
    message.sqFt = object.sqFt ?? 0;
    message.yearBuilt = object.yearBuilt ?? 0;
    return message;
  },
};

function createBaseHomeDetails(): HomeDetails {
  return {
    bathroomsFull: 0,
    bathroomsHalf: 0,
    bedrooms: 0,
    exteriorStories: 0,
    garageSpaces: 0,
    lotSqFt: 0,
    pool: false,
    sqFt: 0,
    yearBuilt: 0,
    aboveGradeSqFt: 0,
    basementSqFt: 0,
  };
}

export const HomeDetails = {
  fromJSON(object: any): HomeDetails {
    return {
      bathroomsFull: isSet(object.bathroomsFull) ? Number(object.bathroomsFull) : 0,
      bathroomsHalf: isSet(object.bathroomsHalf) ? Number(object.bathroomsHalf) : 0,
      bedrooms: isSet(object.bedrooms) ? Number(object.bedrooms) : 0,
      exteriorStories: isSet(object.exteriorStories) ? Number(object.exteriorStories) : 0,
      garageSpaces: isSet(object.garageSpaces) ? Number(object.garageSpaces) : 0,
      lotSqFt: isSet(object.lotSqFt) ? Number(object.lotSqFt) : 0,
      pool: isSet(object.pool) ? Boolean(object.pool) : false,
      sqFt: isSet(object.sqFt) ? Number(object.sqFt) : 0,
      yearBuilt: isSet(object.yearBuilt) ? Number(object.yearBuilt) : 0,
      aboveGradeSqFt: isSet(object.aboveGradeSqFt) ? Number(object.aboveGradeSqFt) : 0,
      basementSqFt: isSet(object.basementSqFt) ? Number(object.basementSqFt) : 0,
    };
  },

  toJSON(message: HomeDetails): unknown {
    const obj: any = {};
    if (message.bathroomsFull !== 0) {
      obj.bathroomsFull = Math.round(message.bathroomsFull);
    }
    if (message.bathroomsHalf !== 0) {
      obj.bathroomsHalf = Math.round(message.bathroomsHalf);
    }
    if (message.bedrooms !== 0) {
      obj.bedrooms = Math.round(message.bedrooms);
    }
    if (message.exteriorStories !== 0) {
      obj.exteriorStories = Math.round(message.exteriorStories);
    }
    if (message.garageSpaces !== 0) {
      obj.garageSpaces = Math.round(message.garageSpaces);
    }
    if (message.lotSqFt !== 0) {
      obj.lotSqFt = Math.round(message.lotSqFt);
    }
    if (message.pool === true) {
      obj.pool = message.pool;
    }
    if (message.sqFt !== 0) {
      obj.sqFt = Math.round(message.sqFt);
    }
    if (message.yearBuilt !== 0) {
      obj.yearBuilt = Math.round(message.yearBuilt);
    }
    if (message.aboveGradeSqFt !== 0) {
      obj.aboveGradeSqFt = Math.round(message.aboveGradeSqFt);
    }
    if (message.basementSqFt !== 0) {
      obj.basementSqFt = Math.round(message.basementSqFt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HomeDetails>, I>>(base?: I): HomeDetails {
    return HomeDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HomeDetails>, I>>(object: I): HomeDetails {
    const message = createBaseHomeDetails();
    message.bathroomsFull = object.bathroomsFull ?? 0;
    message.bathroomsHalf = object.bathroomsHalf ?? 0;
    message.bedrooms = object.bedrooms ?? 0;
    message.exteriorStories = object.exteriorStories ?? 0;
    message.garageSpaces = object.garageSpaces ?? 0;
    message.lotSqFt = object.lotSqFt ?? 0;
    message.pool = object.pool ?? false;
    message.sqFt = object.sqFt ?? 0;
    message.yearBuilt = object.yearBuilt ?? 0;
    message.aboveGradeSqFt = object.aboveGradeSqFt ?? 0;
    message.basementSqFt = object.basementSqFt ?? 0;
    return message;
  },
};

function createBaseListingDetails(): ListingDetails {
  return {
    daysOnMarket: 0,
    listPrice: 0,
    originalListPrice: 0,
    closePrice: 0,
    closeDate: undefined,
    closeDate2: undefined,
    pendingDate: undefined,
    pendingDate2: undefined,
    listDate: undefined,
    listDate2: undefined,
    listingStatus: "",
    sellerConcession: 0,
    statusChangeDate: undefined,
    statusChangeDate2: undefined,
  };
}

export const ListingDetails = {
  fromJSON(object: any): ListingDetails {
    return {
      daysOnMarket: isSet(object.daysOnMarket) ? Number(object.daysOnMarket) : 0,
      listPrice: isSet(object.listPrice) ? Number(object.listPrice) : 0,
      originalListPrice: isSet(object.originalListPrice) ? Number(object.originalListPrice) : 0,
      closePrice: isSet(object.closePrice) ? Number(object.closePrice) : 0,
      closeDate: isSet(object.closeDate) ? fromJsonTimestamp(object.closeDate) : undefined,
      closeDate2: isSet(object.closeDate2) ? DateMessage.fromJSON(object.closeDate2) : undefined,
      pendingDate: isSet(object.pendingDate) ? fromJsonTimestamp(object.pendingDate) : undefined,
      pendingDate2: isSet(object.pendingDate2) ? DateMessage.fromJSON(object.pendingDate2) : undefined,
      listDate: isSet(object.listDate) ? fromJsonTimestamp(object.listDate) : undefined,
      listDate2: isSet(object.listDate2) ? DateMessage.fromJSON(object.listDate2) : undefined,
      listingStatus: isSet(object.listingStatus) ? String(object.listingStatus) : "",
      sellerConcession: isSet(object.sellerConcession) ? Number(object.sellerConcession) : 0,
      statusChangeDate: isSet(object.statusChangeDate) ? fromJsonTimestamp(object.statusChangeDate) : undefined,
      statusChangeDate2: isSet(object.statusChangeDate2) ? DateMessage.fromJSON(object.statusChangeDate2) : undefined,
    };
  },

  toJSON(message: ListingDetails): unknown {
    const obj: any = {};
    if (message.daysOnMarket !== 0) {
      obj.daysOnMarket = Math.round(message.daysOnMarket);
    }
    if (message.listPrice !== 0) {
      obj.listPrice = Math.round(message.listPrice);
    }
    if (message.originalListPrice !== 0) {
      obj.originalListPrice = Math.round(message.originalListPrice);
    }
    if (message.closePrice !== 0) {
      obj.closePrice = Math.round(message.closePrice);
    }
    if (message.closeDate !== undefined) {
      obj.closeDate = message.closeDate.toISOString();
    }
    if (message.closeDate2 !== undefined) {
      obj.closeDate2 = DateMessage.toJSON(message.closeDate2);
    }
    if (message.pendingDate !== undefined) {
      obj.pendingDate = message.pendingDate.toISOString();
    }
    if (message.pendingDate2 !== undefined) {
      obj.pendingDate2 = DateMessage.toJSON(message.pendingDate2);
    }
    if (message.listDate !== undefined) {
      obj.listDate = message.listDate.toISOString();
    }
    if (message.listDate2 !== undefined) {
      obj.listDate2 = DateMessage.toJSON(message.listDate2);
    }
    if (message.listingStatus !== "") {
      obj.listingStatus = message.listingStatus;
    }
    if (message.sellerConcession !== 0) {
      obj.sellerConcession = Math.round(message.sellerConcession);
    }
    if (message.statusChangeDate !== undefined) {
      obj.statusChangeDate = message.statusChangeDate.toISOString();
    }
    if (message.statusChangeDate2 !== undefined) {
      obj.statusChangeDate2 = DateMessage.toJSON(message.statusChangeDate2);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListingDetails>, I>>(base?: I): ListingDetails {
    return ListingDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListingDetails>, I>>(object: I): ListingDetails {
    const message = createBaseListingDetails();
    message.daysOnMarket = object.daysOnMarket ?? 0;
    message.listPrice = object.listPrice ?? 0;
    message.originalListPrice = object.originalListPrice ?? 0;
    message.closePrice = object.closePrice ?? 0;
    message.closeDate = object.closeDate ?? undefined;
    message.closeDate2 = (object.closeDate2 !== undefined && object.closeDate2 !== null)
      ? DateMessage.fromPartial(object.closeDate2)
      : undefined;
    message.pendingDate = object.pendingDate ?? undefined;
    message.pendingDate2 = (object.pendingDate2 !== undefined && object.pendingDate2 !== null)
      ? DateMessage.fromPartial(object.pendingDate2)
      : undefined;
    message.listDate = object.listDate ?? undefined;
    message.listDate2 = (object.listDate2 !== undefined && object.listDate2 !== null)
      ? DateMessage.fromPartial(object.listDate2)
      : undefined;
    message.listingStatus = object.listingStatus ?? "";
    message.sellerConcession = object.sellerConcession ?? 0;
    message.statusChangeDate = object.statusChangeDate ?? undefined;
    message.statusChangeDate2 = (object.statusChangeDate2 !== undefined && object.statusChangeDate2 !== null)
      ? DateMessage.fromPartial(object.statusChangeDate2)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
